<template>
  <div class="zujian">
    <div class="changeCar" v-if="mapData.isChangeCar==1&&changeLog.length>0" >
      <el-tabs type="border-card" v-model="changeCar" @tab-click="handleClick">
        <el-tab-pane :label="changeLog[0].vhcNo" name="xian">
          {{changeLog[0].driverName}}<span>/</span>{{changeLog[0].dirverMobile}}<span>/</span>{{changeLog[0].startTime}} —— {{changeLog[0].endTime}}
        </el-tab-pane>
        <el-tab-pane :label="changeLog[1].vhcNo" name="yuan">
          {{changeLog[1].driverName}}<span>/</span>{{changeLog[1].dirverMobile}}<span>/</span>{{changeLog[1].startTime}} —— {{changeLog[1].endTime}}
        </el-tab-pane>
      </el-tabs>
    </div>
    <div id="map">
    <div class="table" v-if="isDetail">
      <div class="close" @click="closeFn"><i class="el-icon-close"></i></div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="车辆" name="gps">
            <el-table :data="gpsInfos"  ref="vehList"  width="100%" height="260px" v-loading="loading" >
              <el-table-column  type="index"  width="55" label="序号"></el-table-column>
            <el-table-column property=""  width="120" label="车牌号" >
                <template>
                  {{searchFrom.vchNo}}
                </template>
              </el-table-column>
              <!-- :formatter="dateFormat" -->
              <el-table-column prop="gPSDate" width="170"   label="上报时间"></el-table-column>
              <el-table-column prop="addressGrid"  min-width="260" :show-overflow-tooltip="true" label="当前位置"></el-table-column>
              <el-table-column  prop="speed" width="140" label="当前速度(KM/H)" ></el-table-column>
              <el-table-column  prop="direction" width="140" :formatter="fx" label="当前方向" ></el-table-column>
              <el-table-column  prop="encryptLongitude" width="200" :show-overflow-tooltip="true" label="经度" ></el-table-column>
              <el-table-column  prop="encryptDimension" width="200" :show-overflow-tooltip="true" label="纬度" ></el-table-column>
            </el-table>
        </el-tab-pane>
        <!-- <el-tab-pane label="司机" name="siji"  v-if="mapData.type == 1||mapData.type == 3">
            <el-table :data="driInfos"  ref="vehList"  width="100%" height="260px" v-loading="loading"  >
              <el-table-column  type="index"  width="55" label="序号"></el-table-column>
            <el-table-column property=""  width="120" label="司机姓名" >
                <template>
                  {{mapData.dirverName}}
                </template>
              </el-table-column>
              <el-table-column prop="gPSDate" width="170"   label="上报时间"></el-table-column>
              <el-table-column prop="addressGrid" min-width="530"  :show-overflow-tooltip="true" label="当前位置"></el-table-column>
              <el-table-column  prop="encryptLongitude" width="200" :show-overflow-tooltip="true" label="经度" ></el-table-column>
              <el-table-column  prop="encryptDimension" width="200" :show-overflow-tooltip="true" label="纬度" ></el-table-column>
            </el-table>
        </el-tab-pane> -->
      </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import AMap from 'AMap'
import { vhcHisList, zjVhcHisList, driverHisDataList, changeCarLog } from '@/api/vehMonitor'
export default {
  name: 'maphistory',
  props: {
    mapData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      searchFrom: {
        serverName: '中物网络货运'
      },
      marker: null,
      marker1: null,
      map: null,
      polyline: null,
      polyline1: null,
      isPlay: false,
      lineArr: [],
      mapAdress: '',
      lineArr1: [],
      gpsInfos: [],
      driInfos: [],
      isDetail: false,
      activeName: 'gps',
      changeCar: 'xian',
      changeLog: []

    }
  },
  created () {

  },
  mounted () {
    this.initMap()
    if (this.mapData.isChangeCar == 1) {
      changeCarLog({ wayId: this.mapData.id }).then(res => {
        this.changeLog.push({
          vhcNo: res[0].currentVhcNo,
          driverName: res[0].currentDirverName,
          dirverMobile: res[0].currentDirverMobile,
          startTime: this.dateFormat(res[0].endTime),
          endTime: this.dateFormat(this.mapData.arrivalTime),
          dirverId: res[0].currentDirverId
        })
        this.changeLog.push({
          vhcNo: res[0].vhcNo,
          driverName: res[0].driverName,
          dirverMobile: res[0].dirverMobile,
          startTime: this.dateFormat(res[0].startTime),
          endTime: this.dateFormat(res[0].endTime),
          dirverId: res[0].dirverId
        })
        this.searchFn()
      })
    } else {
      this.searchFn()
    }
  },
  methods: {
    searchFn () {
      this.clearFn()
      if (this.mapData.type == 1) { // 配货单包括金泰
        this.searchFrom.startTime = this.dateFormat(this.mapData.trafficTime)
        this.searchFrom.endTime = this.dateFormat(this.mapData.completeTime)
        this.searchFrom.wayNo = this.mapData.distributionNo
      } else if (this.mapData.type == 2) { // 提货单
        this.searchFrom.startTime = this.dateFormat(this.mapData.outTime)
        this.searchFrom.endTime = this.dateFormat(this.mapData.receivingTime)
        this.searchFrom.wayNo = this.mapData.wayNo
      } else if (this.mapData.type == 3) { // 网络货运平台的运单
        this.searchFrom.startTime = this.dateFormat(this.mapData.outTime)
        this.searchFrom.endTime = this.dateFormat(this.mapData.arrivalTime)
        this.searchFrom.wayNo = this.mapData.wayNo
      }
      if (this.mapData.isChangeCar == 1) {
        if (this.changeCar == 'xian') {
          this.searchFrom.vchNo = this.changeLog[0].vhcNo
          this.searchFrom.driverId = this.changeLog[0].dirverId
          this.searchFrom.startTime = this.changeLog[0].startTime
          this.searchFrom.endTime = this.changeLog[0].endTime
          this.mapData.dirverName = this.changeLog[0].driverName
        } else {
          this.searchFrom.vchNo = this.changeLog[1].vhcNo
          this.searchFrom.driverId = this.changeLog[1].dirverId
          this.searchFrom.startTime = this.changeLog[1].startTime
          this.searchFrom.endTime = this.changeLog[1].endTime
          this.mapData.dirverName = this.changeLog[1].driverName
        }
      } else {
        this.searchFrom.vchNo = this.mapData.vhcNo
        this.searchFrom.driverId = this.mapData.dirverId
      }
      this.searchFrom.serverName = '中物网络货运'
      this.loading = true
      vhcHisList(this.searchFrom).then(res => {
        if (res) {
          this.lineArr = res.list
          if (this.lineArr.length > 0) {
            this.polylineFn()
          }

          if (res.flag == 'vms') {
            this.loading = false
            this.gpsInfos = res.gpsInfos ? res.gpsInfos : []
            this.runTime = res.runTime
          } else if (res.flag == 'hbase') {
            this.loading = false
            if (res.gpsInfos.length == 0) {
              zjVhcHisList(this.searchFrom).then(res1 => {
                this.gpsInfos = res1.gpsInfos
                this.runTime = res1.runTime
                this.loading = false
              })
            } else {
              this.gpsInfos = res.gpsInfos
              this.runTime = res.runTime
            }
          } else {
            zjVhcHisList(this.searchFrom).then(res1 => {
              this.gpsInfos = res1.gpsInfos
              this.runTime = res1.runTime
              this.loading = false
            })
          }
          if (this.lineArr.length > 0) {
            this.marker.moveAlong(this.lineArr, 800)
          }
        }
      })
      if (this.mapData.type == 1 || this.mapData.type == 3) {
        // driverHisList(this.searchFrom).then(res => {
        //   this.lineArr1 = res.list
        //   if (this.lineArr1.length > 0) {
        //     this.polylineFn1()
        //     this.marker1.moveAlong(this.lineArr1, 800)
        //   }
        // })
        driverHisDataList(this.searchFrom).then(res => {
          this.loading = false
          this.driInfos = res.gpsInfos
        })
      }
    },
    // 现车原车切换
    handleClick () {
      this.searchFn()
    },
    clearFn () {
      this.map.clearMap()
      this.searchFrom = { time: null }
      this.gpsInfos = []
    },
    initMap () {
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
    },
    polylineFn () {
      var startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(40, 45),
        // 图标的取图地址
        image: require('../assets/dapingImg/装.png'),
        // 图标所用图片大小
        imageSize: new AMap.Size(40, 45),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0)
      })
      var startIcon1 = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(40, 45),
        // 图标的取图地址
        image: require('../assets/dapingImg/卸.png'),
        // 图标所用图片大小
        imageSize: new AMap.Size(40, 45),
        // 图标取图偏移量
        imageOffset: new AMap.Pixel(0, 0)
      })
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lineArr[0],
        // icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png', //经
        icon: startIcon,
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lineArr[this.lineArr.length - 1],
        // icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-via-marker.png', //经
        icon: startIcon1,
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lineArr[0],
        icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/cat.png',
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      // 绘制轨迹
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: this.lineArr,
        showDir: true,
        strokeColor: '#28F', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })

      var passedPolyline = new AMap.Polyline({
        map: this.map,
        // path: lineArr,
        strokeColor: '#AF5', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.marker.on('click', this.showInfoM)
      this.map.setFitView()
    },
    showInfoM (e) {
      this.isDetail = true
      this.isveh = true
      this.activeName = 'gps'
    },
    polylineFn1 () {
      this.marker1 = new AMap.Marker({
        map: this.map,
        position: this.lineArr1[0],
        icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/siji.png',
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      // 绘制轨迹
      this.polyline1 = new AMap.Polyline({
        map: this.map,
        path: this.lineArr1,
        showDir: true,
        strokeColor: '#000000', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })

      var passedPolyline = new AMap.Polyline({
        map: this.map,
        // path: lineArr,
        strokeColor: '#AF5', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      this.marker1.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.marker1.on('click', this.showInfoM1)
      this.map.setFitView()
    },
    showInfoM1 (e) {
      this.isDetail = true
      this.isveh = false
      this.activeName = 'siji'
    },
    closeFn () {
      this.isDetail = false
    },
    fx: function (row, column, cellValue) {
      // 北方向
      if (cellValue >= 0 && cellValue <= 22 || cellValue >= 338 && cellValue <= 360) {
        return '北'
      }
      // 东北方向
      if (cellValue >= 23 && cellValue <= 67) {
        return '东北'
      }
      // 东方向
      if (cellValue >= 68 && cellValue <= 112) {
        return '东'
      }
      // 东南方向
      if (cellValue >= 113 && cellValue <= 157) {
        return '东南'
      }
      // 南方向
      if (cellValue >= 158 && cellValue <= 202) {
        return '南'
      }
      // 西南方向
      if (cellValue >= 203 && cellValue <= 247) {
        return '西南'
      }
      // 西方向
      if (cellValue >= 248 && cellValue <= 292) {
        return '西'
      }
      // 西北方向
      if (cellValue >= 293 && cellValue <= 337) {
        return '西北'
      }
    },
    // 时间格式化
    dateFormat: function (cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
    }
  }
}
</script>

<style scoped lang='less'>
.zujian{
  height: calc(100vh - 40px);
  position: relative;
}
.changeCar{
  position: absolute;
  left: 0;
  right: 0;
  background: #fff;
  z-index: 9999999;
  width:500px;
  span{
    margin: 0 10px;
    color: #409EFF;
  }
}
#map{
  width: 100%;
  height: 100%;
  position: relative;
}
.table{
  position:absolute;
  left: 0;
  bottom:0;
  z-index:9999;
  background: #fff;
  width: 100%;
}
 .close{
    height: 40px;
    position:absolute;
    top:0;
    right: 20px;
    display: flex;
    align-items: center;
    z-index: 99999;
  }
    /deep/.el-tabs__item{
    font-size: 12px;
  }
  /deep/.el-tabs__nav{
    padding-left: 10px;
  }
  /deep/.el-tab-pane{
    font-size: 12px;
  }
  /deep/.el-tabs__active-bar{
    left: 10px;
  }
  /deep/.el-tabs__header{
    margin: 0;
  }
</style>
